module.exports = __webpack_public_path__ + "img/chair.1b296de7.png";